import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { getFormTitleParam, isObjectNotEmpty } from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getFormTitleParamList } from "../../redux/selector";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 15,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
});

function EditFormOwner() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const [domainName, setDomainName] = useState("");

    const [formOwners, setFormOwners] = useState({});

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };

    const [refresh, setRefresh] = useState({});
    const [isCurrFormOwner, setIsCurrFormOwner] = useState(false);
    const [infoInUse, setInfoInUse] = useState(false);
    const [isPostNoContainUser, setIsPostNoContainUser] = useState(false);

    const [apiError, setApiError] = useState(false);

    const [apiErrorMsg, setApiErrorMsg] = useState("");

    const handleConfirm = () => {
        setIsCurrFormOwner(false);
        setInfoInUse(false);
        setIsPostNoContainUser(false);
    };

    const formTitleParam = useSelector(getFormTitleParamList());

    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function addFormOwner(domainName) {
        const newFormOwner = {
            post: domainName,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/users/addFormOwners/${selectedForm}`,
            method: "POST",
            body: JSON.stringify(newFormOwner),
        };
        if (
            formOwners.every(
                (item) =>
                    domainName?.toLowerCase() !=
                    item.post?.trim()?.toLowerCase()
            )
        ) {
            dispatch(send("ADD_FORM_OWNER", option))
                .then((response) => response.json())
                .then((result) => {
                    if (result?.success) {
                        setFormOwners(result?.data);
                    } else if (result?.code === "2001") {
                        setIsCurrFormOwner(true);
                    } else if (result?.code === "2002") {
                        setInfoInUse(true);
                    } else if (result?.code === "2007") {
                        setIsPostNoContainUser(true);
                    } else {
                        setApiError(true);
                        setApiErrorMsg(result?.message);
                    }
                    setDomainName("");
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        } else {
            setIsCurrFormOwner(true);
        }
    }

    function deleteFormOwner(item) {
        const option = {
            url: `${Config.CONTENT_PATH}/users/removeFormOwners/${selectedForm}`,
            method: "PUT",
            body: JSON.stringify(item),
        };
        dispatch(send("REMOVE_FORM_OWNER", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success) {
                    setFormOwners(result?.data);
                } else {
                    setApiError(true);
                    setApiErrorMsg(result?.message);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    // const onSubmit = () => {
    //     setIsSavedOpen(true);
    //     console.log("submitted:" + JSON.stringify(formOwners));
    // };

    const combinedForms = [20, 24, 25, 36, 37, 38, 39, 55, 56, 60, 61, 77, 105];
    const formList = Array.from({ length: 107 }, (_, i) => i + 1).filter(
        (id) => !combinedForms.includes(id)
    );
    const [selectedForm, setSelectedForm] = useState(formList[0]);

    useEffect(() => {
        const option = {
            url: `${Config.CONTENT_PATH}/users/formOwners/${selectedForm}`,
        };
        dispatch(send("GET_FORM_OWNER", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success) {
                    setFormOwners(result?.data);
                } else {
                    setApiError(true);
                    setApiErrorMsg(result?.message);
                }
                setDomainName("");
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }, [refresh, selectedForm]);

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.editFormOwner")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                {formList.length > 0 && selectedForm != 0 && (
                    <Box className="main">
                        <Box>
                            <Typography component="span">
                                {t("common.portal.forForm")}&nbsp;
                            </Typography>

                            <FormControl id="formsId">
                                <Select
                                    label="formsId"
                                    inputProps={{
                                        "aria-labelledby": "formsId",
                                    }}
                                    defaultValue={selectedForm}
                                    style={{ textAlign: "end" }}
                                    onChange={(e) =>
                                        setSelectedForm(e.target.value)
                                    }
                                >
                                    {formList?.map((element) => (
                                        <MenuItem value={element} key={element}>
                                            {element}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Typography component="span">
                                {t("common.colon")}
                            </Typography>
                            <Typography>
                                {t(
                                    `form.Form${selectedForm
                                        .toString()
                                        .padStart(3, "0")}`,
                                    getFormTitleParam(
                                        selectedForm,
                                        formTitleParam,
                                        i18n.language
                                    )
                                )}
                            </Typography>
                        </Box>
                        <Typography variant="h6" component="h1">
                            <br />
                            {t("common.portal.editCurrentFormOwners")}
                        </Typography>
                        <TableContainer component={Paper}>
                            <Table
                                // className={classes.table}
                                stickyHeader
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.name")}
                                        </TableCell> */}
                                        {/* <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t(
                                                "common.portal.interfaceUsername"
                                            )}
                                        </TableCell> */}
                                        {/* <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.email")}
                                        </TableCell> */}
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.post")}
                                        </TableCell>
                                        <TableCell component="td"></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {isObjectNotEmpty(formOwners)
                                        ? formOwners?.map((item) => (
                                              <React.Fragment key={item.post}>
                                                  <TableRow>
                                                      {/* <TableCell align="center">
                                                          {item.name}
                                                      </TableCell> */}
                                                      {/* <TableCell align="center">
                                                          {
                                                              item.interfaceUsername
                                                          }
                                                      </TableCell> */}
                                                      {/* <TableCell align="center">
                                                          <a
                                                              href={`mailto:${item.email}`}
                                                              style={{
                                                                  color: "black",
                                                              }}
                                                          >
                                                              {item.email}
                                                          </a>
                                                      </TableCell> */}
                                                      <TableCell align="center">
                                                          {item.post}
                                                      </TableCell>
                                                      <TableCell
                                                          style={{
                                                              width: "10px",
                                                          }}
                                                      >
                                                          <IconButton
                                                              onClick={() =>
                                                                  deleteFormOwner(
                                                                      item
                                                                  )
                                                              }
                                                              color="primary"
                                                              aria-label="del"
                                                          >
                                                              <RemoveCircleIcon />
                                                          </IconButton>
                                                      </TableCell>
                                                  </TableRow>
                                              </React.Fragment>
                                          ))
                                        : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Paper>
                            <br />
                            <CustomTextField
                                label={
                                    <>
                                        <Typography component="span">
                                            {t(
                                                "common.portal.typeDomainNameFormOwnerStart"
                                            )}
                                        </Typography>
                                        <AddCircleIcon
                                            style={{
                                                margin: "0 5px",
                                                color: "#A74128",
                                            }}
                                        />
                                        <Typography component="span">
                                            {t(
                                                "common.portal.typeDomainNameFormOwnerEnd"
                                            )}
                                        </Typography>
                                    </>
                                }
                                id="typeDomainNameFormOwner"
                                placeholder={t(
                                    "common.portal.pleaseInputDomainNameFormOwner"
                                )}
                                value={domainName}
                                onChange={(e) => setDomainName(e.target.value)}
                                style={{ width: matches ? "90%" : "85%" }}
                                displayColon={false}
                            ></CustomTextField>
                            <IconButton
                                onClick={() => {
                                    if (domainName != "")
                                        addFormOwner(domainName);
                                }}
                                style={{ marginTop: "0.8rem" }}
                                color="primary"
                                aria-label="add"
                            >
                                <AddCircleIcon />
                            </IconButton>
                        </Paper>
                        <br />
                        <br />
                    </Box>
                )}
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
            <AlertDialog
                formOpen={infoInUse}
                content={
                    <React.Fragment>
                        <Typography>
                            {t("common.portal.noDomainNameUser")}
                        </Typography>
                        <Typography>{t("common.portal.checkAgain")}</Typography>
                    </React.Fragment>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isCurrFormOwner}
                content={
                    <Typography>
                        {t("common.portal.alreadyIncludedFormOwner")}
                    </Typography>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isPostNoContainUser}
                content={
                    <Typography>
                        {t("common.portal.postNoContainUser")}
                    </Typography>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={apiError}
                content={<Typography>{apiErrorMsg}</Typography>}
                confirmButton={{
                    action: () => {
                        setApiError(false);
                        setApiErrorMsg("");
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </Container>
    );
}
export default EditFormOwner;
